import { useContext } from 'react';
import { ChatContext } from '../contexts/ChatContext';

/**
 * Hook to access the chat context.
 * Provides access to the handleSend function from ChatContainer,
 * allowing any component to send messages through the chatbot.
 *
 * @throws Error if used outside of ChatProvider
 * @returns ChatContext value containing handleSend function
 */
export const useChat = () => {
  const context = useContext(ChatContext);

  if (context === undefined) {
    throw new Error('useChat must be used within a ChatProvider');
  }

  return context;
};
